import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React, { useCallback, useEffect } from "react";
import { format } from "date-fns";

//Services
import InvoiceService from '../../../services/invoice.service';

const Dashboard = () => {
    const [invoicesWeek, setInvoicesWeek] = React.useState(0);
    const [invoicesDay, setInvoicesDay] = React.useState(0);
    const [invoicesMonth, setInvoicesMonth] = React.useState(0);

    //Date functions
    let currentDate = new Date();
    let tomorrowDate = new Date(currentDate);
    tomorrowDate.setDate(currentDate.getDate() + 1);

    let firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    let lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    // Compute Monday-Sunday range for current week (independent of week numbering)
    const dayOfWeek = currentDate.getDay(); // 0=Sun, 1=Mon, ..., 6=Sat
    const daysSinceMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
    let monday = new Date(currentDate);
    monday.setDate(currentDate.getDate() - daysSinceMonday);
    let sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);


    const fetchInvoicesWeekHandler = useCallback(async () => {
        try {
            const result = await InvoiceService.getInvoicesPaginated({
                page: 1,
                limit: 1,
                sortBy: 'createdAt',
                sortOrder: 'desc',
                dateFrom: format(monday, 'yyyy-MM-dd'),
                dateTo: format(sunday, 'yyyy-MM-dd'),
            });
            setInvoicesWeek(result?.pagination?.total ?? 0);
        } catch (error) {
            console.error(error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchInvoicesDayHandler = useCallback(async () => {
        try {
            const result = await InvoiceService.getInvoicesPaginated({
                page: 1,
                limit: 1,
                sortBy: 'createdAt',
                sortOrder: 'desc',
                dateFrom: format(currentDate, 'yyyy-MM-dd'),
                dateTo: format(currentDate, 'yyyy-MM-dd'),
            });
            setInvoicesDay(result?.pagination?.total ?? 0);
        } catch (error) {
            console.error(error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchInvoicesMonthHandler = useCallback(async () => {
        try {
            const result = await InvoiceService.getInvoicesPaginated({
                page: 1,
                limit: 1,
                sortBy: 'createdAt',
                sortOrder: 'desc',
                dateFrom: format(firstDay, 'yyyy-MM-dd'),
                dateTo: format(lastDay, 'yyyy-MM-dd'),
            });
            setInvoicesMonth(result?.pagination?.total ?? 0);
        } catch (error) {
            console.error(error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    useEffect(() => {
        void fetchInvoicesWeekHandler();
        void fetchInvoicesDayHandler();
        void fetchInvoicesMonthHandler();
    }, [fetchInvoicesWeekHandler, fetchInvoicesDayHandler, fetchInvoicesMonthHandler])

    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 'calc(100vh - 200px)',
        }}>
            <Container maxWidth="md" disableGutters>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 2,
                }}>
                        <Box sx={{width: '30%'}} >
                            <Box sx={{border: '2px solid green', borderRadius: '5px'}}>
                                <Typography component="h5"
                                            sx={{
                                                color: 'green',
                                                fontSize: '25px',
                                                textAlign: 'center'
                                            }}>
                                    Remisiones semana
                                </Typography>
                            </Box>
                            <Box sx={{border: '2px solid green', borderRadius: '5px', marginTop: '15px'}}>
                                <Typography component="h5"
                                            sx={{
                                                color: 'green',
                                                fontSize: '100px',
                                                textAlign: 'center'
                                            }}>
                                    {invoicesWeek}
                                </Typography>
                            </Box>
                        </Box>
                    <Box sx={{width: '30%'}} >
                        <Box sx={{border: '2px solid green', borderRadius: '5px'}}>
                            <Typography component="h5"
                                        sx={{
                                            color: 'green',
                                            fontSize: '25px',
                                            textAlign: 'center'
                                        }}>
                                Remisiones hoy
                            </Typography>
                        </Box>
                        <Box sx={{border: '2px solid green', borderRadius: '5px', marginTop: '15px'}}>
                            <Typography component="h5"
                                        sx={{
                                            color: 'green',
                                            fontSize: '100px',
                                            textAlign: 'center'
                                        }}>
                                {invoicesDay}
                            </Typography>
                        </Box>
                    </Box>
                    <Box sx={{width: '30%'}} >
                        <Box sx={{border: '2px solid green', borderRadius: '5px'}}>
                            <Typography component="h5"
                                        sx={{
                                            color: 'green',
                                            fontSize: '25px',
                                            textAlign: 'center'
                                        }}>
                                Remisiones mes
                            </Typography>
                        </Box>
                        <Box sx={{border: '2px solid green', borderRadius: '5px', marginTop: '15px'}}>
                            <Typography component="h5"
                                        sx={{
                                            color: 'green',
                                            fontSize: '100px',
                                            textAlign: 'center'
                                        }}>
                                {invoicesMonth}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Container>
        </Box>
    )
}

export default Dashboard